export default "__VITE_ASSET__D9sAcy23__"